module.exports = __webpack_public_path__ + "static/media/park_icon.00bf0c54.svg";